<template>
  <div>
    <div class="section-background">

        <!-- TO DO integrate form-properties with form-section (form properties are just like form questions) -->


        <div v-for="(activity, index) in activities">
          <form-properties v-if="activity['name'] == 'Gegevens Opdrachtgever'" :activityIndex="index" />
          <form-section v-else v-bind:key="index" :activityIndex="index" />
        </div>

    </div>
    <!-- <form-steps
    :index="active"
    @clicked="changeActive"/> -->
    <submit-form @submitted="changeStatus"/>
  </div>
</template>

<script>

// import axios from 'axios'
import Section from './Section'
import Properties from './Properties'
import FormSteps from '../elements/footer/FormSteps'
import SubmitForm from '../elements/footer/SubmitForm'

export default {
  name: 'BasicForm',
  components: {
    'form-section': Section,
    'form-properties': Properties,
    'form-steps': FormSteps,
    'submit-form': SubmitForm
  },
  data () {
    return {
      active: this.$store.getters.getActiveActivity,
      activities: this.$store.getters.getActivities,
      component: 'start',
      slide: 'slide-left'
    }
  },
  methods: {
    changeActive (index) {
      if (this.active > index) {
        this.slide = 'slide-right'
      } else {
        this.slide = 'slide-left'
      }
      this.$store.commit('setActiveActivity', index)
      // this.$store.commit('setActiveQuestion', 0)
      this.active = index
    },
    changeStatus () {
      this.$emit('form-status', 'sent')
    }
  }
}
</script>

<style scoped>

.note {
  width: 20%;
  margin-left: 40%
}

.section-background {
    background-image: linear-gradient(white 20%, #f8f8f8);
    padding-bottom: 1px;
    padding-left: 20px;
    padding-right: 20px;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-left-enter-active {
  transition: all .4s ease;
}
.slide-left-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-left-enter, .slide-left-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(500px);
  opacity: 0;
}
.slide-left-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(-500px);
  opacity: 0;
}

.slide-right-enter-active {
  transition: all .4s ease;
}
.slide-right-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-right-enter, .slide-right-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(-500px);
  opacity: 0;
}
.slide-right-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(500px);
  opacity: 0;
}

/* .slide-leave-active,
.slide-enter-active {
  transition: 500ms;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
} */

</style>



// WEBPACK FOOTER //
// src/components/layout/SinglePageSurvey.vue